module["exports"] = [
  "082 ### ####",
  "083 ### ####",
  "085 ### ####",
  "086 ### ####",
  "087 ### ####",
  "089 ### ####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IE/cell_phone/formats.js
// module id = 975
// module chunks = 1